/**
 * VERSIONE LIBRERIA 3
 */
/**
 * renderizza il decimale in due controlli distinti
 **/
var RenderDecimal = Render.extend({
    int_selector    : '[data-render_control_int]',
    dec_selector    : '[data-render_control_dec]',
    symbol_selector : '[data-render_symbol]',
    type : 'decimal',
    classData : 'decimal',
    classTemplate : 'decimal',
    digits : 2,
    symbol : null,
    symbol_position : 'left',
    separator : ",",

    _splitNumber : function () {
        var self = this;
        var value = parseFloat(self.value);
        if (isNaN(value )) {
            self.value = 0;
            return ['0',Array(self.digits+1).join('0')];
        }

        var tmp = (value+"").split(".");
        if (tmp.length == 2) {
            //console.log(tmp,tmp[1].length,self.digits);
            if (tmp[1].length >= self.digits) {
                tmp[1] = tmp[1].substr(0,self.digits);
            }
            else {
                tmp[1] = ""+tmp[1] + Array((self.digits-tmp[1].length)+1).join('0');
            }
            //console.log(tmp);
        } else {
            tmp = [value,Array((self.digits)+1).join('0')]
        }

        return tmp;
    },
    _renderEdit : function(jQe) {
        var self = this;
        var n = self._splitNumber();

        jQe.find(self.control_selector).attr('name',self.key).attr('value',self.value);
        jQe.find(self.int_selector).attr('value',n[0]);
        jQe.find(self.dec_selector).attr('value',n[1]);

        self._showSymbol(jQe);
    },
    _finalizeEdit : function(){
        var self = this;
        $(self.container).find(self.int_selector + "," + self.dec_selector).change(function () {
            var i = $(self.container).find(self.int_selector).val();
            var d = $(self.container).find(self.dec_selector).val();
            $(self.container).find(self.control_selector).attr('value',i+'.'+d);
            jQuery(self.container).find(self.control_selector).trigger('change');
        });
    },

    _showSymbol : function(jQe) {
        var self = this;
        if (self.symbol) {
            jQe.find('[data-render_symbol]').html(self.symbol);
            if (self.symbol_position === 'left' ) {
                jQe.find('.symbol_left').removeClass('hide');
            } else {
                jQe.find('.symbol_right').removeClass('hide');
            }
        }
    },
    _renderView : function (jQe) {
        var self = this;
        var n = self._splitNumber();
        var num = n[0];
        if (n[1].length > 0) {
            num = num + self.separator+n[1];
        }
        jQe.find(self.int_selector).html(num);
        self._showSymbol(jQe);

    },

    _finalizeView : function(){},

    getValue : function () {
        return $(self.container).find(self.control_selector).val();
    },
    setValue : function (doubleVal) {
        var self = this;
        var tmp = new String(doubleVal).split('.');
        var intvalue = tmp[0];
        var decimalvalue = 0;
        if(tmp.length = 2) {
            decimalvalue = tmp[1];
        }
        $(self.container).find(self.int_selector).val(intvalue);
        $(self.container).find(self.dec_selector).val(decimalvalue);
    }
});
